import React, {PureComponent} from "react";
import ReadMore from "../ReadMore/ReadMore";
import Common from "../../utils/common";
import "./AssetDetails.scss";
import SocialNetworks from "./SocialNetworks/SocialNetworks";
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";


class AssetDetails extends PureComponent {

    render() {
        const {asset, enableAmbassador, ambassador} = this.props;
        const isAmbassadorAvailable = enableAmbassador && (ambassador !== null);
        const url = asset.hasOwnProperty("title") ? Common.generateAssetUrlFrom(asset) : "";
        return <div className={"tabs col-12 col-sm-9"}>
            <div className={"asset-meta ambassador-desktop"}>
                <div className={"flex-child "}>
                    {isAmbassadorAvailable && <div className={"ambassador-profile"}>
                        <a href={`${ClientConfigurationHelper.getGlobalConfiguration().sub_folder}/a/${ambassador.user_slug}/${ambassador.user_id}`}>
                            <div className={"ambassador-profile-image"}
                                 style={{backgroundImage: `url(${AmbassadorHelper.getAmbassadorPhotoFromApi(ambassador)})`}}>

                            </div>
                            <div className={"ambassador-profile-name"}>
                                {AmbassadorHelper.getDisplayNameFromApi(ambassador)}
                                <div className={"published"}>
                                    VISIT MY STOREFRONT
                                </div>
                            </div>
                        </a>
                    </div>}
                </div>
                <div className={"flex-child "+(isAmbassadorAvailable ? "": "no-ambassador")}>
                    <SocialNetworks url={url} asset={asset}/>
                </div>

            </div>
            <ReadMore
                lines={2}
                transcripts={asset.data.transcripts}
                more="Show More"
                less="Show Less">
                {asset && asset.description}
            </ReadMore>
            <div className={"ambassador-mobile"}>
                <div className={""}>
                    {isAmbassadorAvailable && <div className={"ambassador-mobile-profile row"}>
                        <a href={`${ClientConfigurationHelper.getGlobalConfiguration().sub_folder}/a/${ambassador.user_slug}/${ambassador.user_id}`} className={"col-12"}>
                            <div className={"ambassador-mobile-profile-image"}
                                 style={{backgroundImage: `url(${AmbassadorHelper.getAmbassadorPhotoFromApi(ambassador)})`}}>
                            </div>
                            <div className={"ambassador-mobile-profile-name"}>
                                {AmbassadorHelper.getDisplayNameFromApi(ambassador)}
                                <div className={"published"}>
                                    VISIT MY STOREFRONT
                                </div>
                            </div>
                        </a>
                    </div>}
                </div>
                <div className={"social-mobile"}>
                    <div className={"social-mobile-title"}>
                        SHARE
                    </div>
                    <div className={"social-mobile-networks"}>
                        <SocialNetworks url={url} asset={asset} />
                    </div>
                </div>
            </div>
        </div>
    }
}

AssetDetails.defaultProps = {
    enableAmbassador: ClientConfigurationHelper.isAmbassadorProgramEnabled(),
    ambassador: null
};

export default AssetDetails;